import { useAppDispatch, useAppSelector } from "../../../redux-tool-kit/Hooks";
import { Filter } from "react-feather";
import { Link } from "react-router-dom";
import { Href } from "../../../utils/Constant";
import { setFilterToggle } from "../../../redux-tool-kit/reducers/OrganizationSlice";
import { useTranslation } from "react-i18next";
import CommonDropDown from "../../common/CommonDropDown";

const OrganizationListFilterHeader = () => {
  const { filterToggle } = useAppSelector((state: any) => state.product);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-between align-items-center gap-2">
      <div className="light-box" onClick={() => dispatch(setFilterToggle())}>
        <Link to={Href}>
          <Filter className={`filter-icon ${filterToggle ? "hide" : "show"}`} />
          <i
            className={`icon-close filter-close ${
              filterToggle ? "show" : "hide"
            }`}
          />
        </Link>
      </div>
      <Link
        className="btn btn-primary"
        to={`${process.env.PUBLIC_URL}/organization/add`}
      >
        <i className="fa fa-plus" />
        {t("AddOrganization")}
      </Link>
      <CommonDropDown color="info" />
    </div>
  );
};

export default OrganizationListFilterHeader;
